import React from 'react';
import { MgpGaugeChart } from '../components/MgpGaugeChart/MgpGaugeChart';
import { ResultsHeading, ResultsWrapper } from './GoalsStyles';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';

export const GoalsLoading = () => {
  return (
    <>
      <MgpGaugeChart />
      <ResultsWrapper>
        <ResultsHeading>Results</ResultsHeading>
        <Shimmer width="85%" height="20px" />
        <Shimmer width="70%" height="20px" mt="8" />
      </ResultsWrapper>
    </>
  );
};
